<template>
  <div  >
    <b-card no-body class="shadow flex-container grid-stack-item-content point-settings" >
      <div slot="header">
        <window-header cmp-title="3d wellpad model layers" widget-name="seam_layers"></window-header>
      </div>
      <div class="card-body flex-full-height p-2" >
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordion1>Raw seam layers</b-btn>
          </b-card-header>
          <b-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel" class="scroll-auto fix-height ">
            <b-card-body >
              <b-form-group>
                <b-form-radio-group stacked v-model="selected" name="flavour2" :options="pc" class="p-1">
                </b-form-radio-group>
              </b-form-group>
            </b-card-body>
          </b-collapse>

        </b-card>

        <!--<b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordion2>Other layers</b-btn>
          </b-card-header>
          <b-collapse id="accordion2" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-form-group>
                <b-form-checkbox-group stacked v-model="selectedOther" name="flavour2" :options="other" class="p-1">
                </b-form-checkbox-group>
              </b-form-group>
            </b-card-body>
          </b-collapse>

        </b-card>-->
      </div>
    </b-card>
  </div>
</template>

<script>
  import WindowHeader from './common/WindowHeader'
  import { scaleOrdinal, schemeCategory20 } from 'd3-scale'
  import store from '../store'

  let colorScale = scaleOrdinal(schemeCategory20)

  export default {
    name: 'SeamLayers',
    components: {WindowHeader},
    data () {
      return {
        currentSeam: null,
        pc: [],
        other: ['well_drillstrings'],
        selected: {},
        selectedOther: []
      }
    },
    computed: {
      currentProject () {
        return store.getters['project/currentProject']
      }
    },
    mounted () {
      this.loadSeamIdents()
    },
    methods: {
      loadSeamIdents() {
        let me = this
        this.$http.get('/api/layers/seams-list')
          .then(res => {
            me.pc.splice(0, me.pc.length)
            me.pc.push.apply(me.pc, res.body.map((l, i) => {
              return {
                value: {name: l, color: colorScale(i)},
                text: l,
                name: l
              }
            }))
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not load seam list',
              type: 'error'
            })
          })
      },
      loadLaterals (o) {
        if (this.$potreeService.layerExists('well_drillstrings')) {
          this.$potreeService.removeVectorLayer.call(this.$potreeService, {name: 'well_drillstrings'})
        }

        if (this.$potreeService.layerExists('drainage')) {
          this.$potreeService.removeVectorLayer.call(this.$potreeService, {name: 'drainage'})
        }
        this.$potreeService.createCylinderLayer.call(this.$potreeService, 'drainage', null,  o.name, this.currentProject.workpack.id)
        this.$potreeService.createLineLayer.call(this.$potreeService, 'well_drillstrings', this.currentProject.workpack.id, 0x00FF00, undefined, o.name)
      },
      HEXToVBColor(rrggbb) {
        var bbggrr = rrggbb.substr(4, 2) + rrggbb.substr(2, 2) + rrggbb.substr(0, 2)
        return parseInt(bbggrr, 16)
      }
    },
    watch: {
      selected (val) {

        if (this.currentSeam && this.$potreeService.layerExists(this.currentSeam)) {
          this.$potreeService.removeVectorLayer.call(this.$potreeService, {name: this.currentSeam})
        }
        this.$potreeService.createLineLayer(val.name, this.currentProject.workpack.id, this.HEXToVBColor(val.color))
        let layerItemArms
        let layerItemGiip
        this.pc.forEach(seam => {
          let seamIdent = seam.name
          console.log(seamIdent)
          this.$mapService.walkTree(store.getters['map/layersTree'], l => {
            if (l['name'].includes(`v4:arms_${seamIdent}`.toLowerCase())) {
              l['checked'] = false
              store.dispatch('map/layerState', l)
              console.log(`removing... ${l['name']}`)
            }

            if (l['name'].includes(`giip:${seamIdent}`.toLowerCase())) {
              l['checked'] = false
              store.dispatch('map/layerState', l)
            }

            if (l['name'].includes(`v4:arms_${val.name}`.toLowerCase())) {
              layerItemArms = l
            }

            if (l['name'].includes(`giip:${val.name}`.toLowerCase())) {
              layerItemGiip = l
            }


          })
        })

        if (layerItemArms) {
          layerItemArms['checked'] = true
          store.dispatch('map/layerState', layerItemArms)
        }

        if (layerItemGiip) {
          layerItemGiip['checked'] = true
          store.dispatch('map/layerState', layerItemGiip)
        }

        // this.$potreeService.createSeamPointLayer(val.name, this.HEXToVBColor(val.color))
        this.loadLaterals(val)
        this.currentSeam = val.name

        /*this.pc.forEach(l => {
          let index = val.map(ll => ll.name).indexOf(l.name)
          if (index === -1) {
            if (this.$potreeService.layerExists(l.name)) {
              this.$potreeService.removeVectorLayer.call(this.$potreeService, l)
            }

          }
        })



        val.forEach((l, i) => {
          if (!this.$potreeService.layerExists(l.name)) {
            this.$potreeService.createLineLayer(l.name, 6, this.HEXToVBColor(l.color))
          }

        })*/
      },

      selectedOther (val) {
        if (!val.length) {
          this.$potreeService.removeVectorLayer.call(this.$potreeService, {name: 'well_drillstrings'})
        } else {
          this.$potreeService.createCylinderLayer.call(this.$potreeService)
        }

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SeamLayers.vue